

    export default {
        name: "FiveStarInsurerSideBySideSection",
        props: {
            anchorLink: {
                type: String,
                default: '#'
            },
            data: {
                type: Array,
                default: () => ([])
            },
            title: {
                type: String
            },
            code: {
                type: String
            },
            titleImage: {
                type: Object
            }
        },
        data() {
            return {
                isActive: [false, false, false, false, false, false],
            }
        },
        computed: {
            computedIsActive() {
                return this.isActive;
            },
            rightImageScr() {
                return this.data?.headImage?.url;
            },
            
        },
        mounted() {
        },
        methods: {
            toggleRemark(index) {
                this.isActive.splice(index,1,!this.isActive[index])
            },
            iconSrc(icon) {
                return require(`@/assets/images/family/icon/${icon}.png`)
            }
        },
    }
